
import { useState, useEffect } from 'react';

interface NavbarProps {
  scrollToSection: (id: string) => void;
}

export default function Navbar({ scrollToSection }: NavbarProps) {
  const [navbarScrolled, setNavbarScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setNavbarScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    // Cleanup to avoid memory leaks
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        navbarScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/83999964-387b-44ed-a0c8-3586f011ed2f.png"
            alt="Advocacia Direitos do Passageiro"
            className="h-12 w-auto object-contain"
          />
          <div>
            <h1 className="text-lg font-bold text-gray-900">Skarlett Marcelino</h1>
            <p className="text-xs text-gray-600">OAB/ES 34.325</p>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('quanto-receber')}
            className={`text-sm font-medium transition-colors hover:text-teal-600 cursor-pointer ${
              navbarScrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Quanto Posso Receber
          </button>

          <button
            onClick={() => scrollToSection('como-funciona')}
            className={`text-sm font-medium transition-colors hover:text-teal-600 cursor-pointer ${
              navbarScrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Como Funciona
          </button>

          <button
            onClick={() => scrollToSection('contato')}
            className={`text-sm font-medium transition-colors hover:text-teal-600 cursor-pointer ${
              navbarScrolled ? 'text-gray-700' : 'text-white/90'
            }`}
          >
            Contato
          </button>

          <button
            onClick={() => scrollToSection('contato')}
            className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-bold px-6 py-2.5 rounded-full transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Análise Gratuita
          </button>
        </div>
      </div>
    </nav>
  );
}
